import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyToZero'
})
export class EmptyToZeroPipe implements PipeTransform {

  transform(amt: any): any {
    if (amt === ''){
        return '$0';
    }
    else {
        return amt;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/empty-to-zero.pipe.ts